<div class="grid-container padding-y-4">
	<div class="grid-row">
		<div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
		  <legend class="usa-legend usa-legend--large">Shipment Booking Audit Trail: {{this.bookShipmentId}}</legend>
		</div>
	</div>

	<div class="grid-row">
		<div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
			<ag-grid-angular
				class="ag-theme-alpine margin-top-2"
				[gridOptions]="shipmentAuditTrailGridOption"
				[rowData]="auditTrailLogList"
				[columnDefs]="columnDefs"
				[suppressDragLeaveHidesColumns]="true"
				ag-grid-resize>
			</ag-grid-angular>
		</div>
	</div>
	<!-- <div class="grid-row">
		<div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
			<table class="usa-table usa-table--borderless usa-table--striped">
				<thead>
					<tr>
						<th id="customerCode" aria-label="Customer Code Heading">Date</th>
						<th id="customerName" aria-label="Customer Name Heading">Time</th>
						<th id="bureauCode" aria-label="Bureau Code Heading">Field
							Name</th>
						<th id="bureauName" aria-label="Bureau Name Heading">From</th>
						<th id="location" aria-label="Location Heading">To</th>
						<th id="userName" aria-label="User Heading">User Email Address</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let auditTrailDeails of auditTrailLogListSliced">
						<td class="readonly">{{auditTrailDeails.updateDate | date:'shortDate'}}</td>
						<td class="readonly">{{auditTrailDeails.updateDate | date:'mediumTime'}}</td>
						<td class="readonly">{{auditTrailDeails.fieldName}}</td>
						<td class="readonly">{{auditTrailDeails.oldValue}}</td>
						<td class="readonly">{{auditTrailDeails.newValue}}</td>
						<td class="readonly">{{auditTrailDeails.updateEmailAddress}}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
			<app-pagination [totalItems]="totalItems"
				[itemsPerPage]="itemsPerPage" [currentPage]="currentPage"
				(itemsPerPageChange)="itemsPerPageChanged($event)"
				(currentPageChange)="page($event)">
			</app-pagination>
		</div>
	</div> -->
	<div class="grid-row">
		<button type="button" class="usa-button usa-button--outline" (click)="goBack()" >Back</button>
	</div>
</div>